// Как использовать контекст сообщений в React
// import { MessageContext } from '../context/MessageContext';
// const { setMess } = useContext(MessageContext);
// setMess({ color: 'red', title: 'Валидация', desc: 'Правильно заполните все поля в форме' });
// Этот код создает контекст сообщений в React, который позволяет отправлять уведомления с помощью библиотеки Toastify.
// Он использует хук useEffect для отображения уведомления, когда состояние сообщения изменяется.
// Он также определяет классы для различных цветов уведомлений и их описаний, которые используются для стилизации уведомлений.

import { createContext, useState, useEffect } from 'react';
import Toastify from 'toastify-js';

export const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [mess, setMess] = useState(null);
  const colorClasses = {
    red: 'group bg-red-500 text-red-50',
    blue: 'group bg-blue-9 text-blue-50',
    gray: 'group bg-gray-500 text-gray-50',
    green: 'group bg-green-500 text-green-50',
    yellow: 'group bg-yellow-500 text-yellow-50'
  };

  const colorClassesDesc = {
    red: 'dark:bg-red-700/90',
    blue: 'dark:bg-blue-700/90',
    gray: 'dark:bg-gray-700/90',
    green: 'dark:bg-green-700/90',
    yellow: 'dark:bg-yellow-700/90'
  };

  useEffect(() => {
    if (mess) {
      Toastify({
        text:`<li class="group pointer-events-auto relative flex w-full items-center justify-between space-x-2 overflow-hidden rounded-md p-4 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full select-none ${colorClasses[mess.color]}">
        <div class="grid w-full gap-1">
          <div class="text-sm font-semibold">
           <span class="flex items-center">
              ${mess.title} ${mess?.duration ? `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 ml-1" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m17.942 6.076l2.442 2.442a1.22 1.22 0 0 1-.147 1.855l-1.757.232a1.697 1.697 0 0 0-.94.452c-.72.696-1.453 1.428-2.674 2.637c-.21.212-.358.478-.427.769l-.94 3.772a1.22 1.22 0 0 1-1.978.379l-3.04-3.052l-3.052-3.04a1.221 1.221 0 0 1 .379-1.978l3.747-.964a1.8 1.8 0 0 0 .77-.44c1.379-1.355 1.88-1.855 2.66-2.698c.233-.25.383-.565.428-.903l.232-1.783a1.221 1.221 0 0 1 1.856-.146zm-9.51 9.498L3.256 20.75"/>
              </svg>` : ''}
            </span>
          </div>
          <div class="text-sm opacity-90">
            <div class="group relative w-full rounded bg-white/20 ${colorClassesDesc[mess.color]}">
              <div class="relative overflow-hidden w-full p-1 font-mono text-white ">
                <div class="h-full w-full rounded-[inherit] max-h-32 overflow-hidden ">
                  <div class="table min-w-full">
                    <span class="break-word text-sm">${mess.desc} </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
  `,
        selector: "alerts",
        close: true,
        escapeMarkup: false,
        gravity: "bottom",
        position: "right",
        //duration: process.env.REACT_APP_VPS_SERVER === '1' ? '4000' : "-1",
        duration: mess?.duration ? mess.duration : '4000',
        ariaLive: "polite",
        className:"transition-all duration-500 shadow-lg [&>.toast-close]:block",
        // avatar: "https://t.me/i/userpic/320/z0C85YT6joSVV-n1lQij2HXmUiV-NnqmCtw62al7nng.jpg",
      }).showToast();
    }
  }, [mess]);

  return (
    <MessageContext.Provider value={{ setMess }}>
      {children}
    </MessageContext.Provider>
  );
};